module.exports = __webpack_public_path__ + "media/images/mac_banner@3x-8ad45ff1c091eaaf852e4c13a314071e.png";